import { render } from "./Speaker.vue?vue&type=template&id=ec3e72f4&ts=true&lang=pug"
import script from "./Speaker.vue?vue&type=script&setup=true&lang=ts"
export * from "./Speaker.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__